import { FadeUp } from "@/components/motion";

const PRINCIPLES = [
  {
    n: "01",
    title: "Strategy before writing",
    body: "Most CV services start with the wording. We start with direction: the roles you're targeting, and what a credible case for them actually requires. The writing comes last.",
  },
  {
    n: "02",
    title: "Evidence over adjectives",
    body: "\u201CMotivated\u201D and \u201Cpassionate\u201D persuade nobody. Achievements, outcomes, scale and complexity do. Every claim in your documents should be substantiated by something real.",
  },
  {
    n: "03",
    title: "Alignment to target roles",
    body: "Your experience is repositioned around what your next employer needs to see — not presented as a complete record of everything you've ever done.",
  },
  {
    n: "04",
    title: "One narrative, everywhere",
    body: "Your CV and LinkedIn profile are built to make the same case, so wherever an employer looks, your positioning holds together.",
  },
];

export default function Approach() {
  return (
    <section data-testid="approach" id="approach" className="relative bg-[#0A0A0A] py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp className="mb-16 md:mb-24 max-w-2xl">
          <p className="tracking-label text-[11px] uppercase font-body font-bold text-[#DFFF00] mb-6">The Approach</p>
          <h2 className="font-display font-bold tracking-tighter leading-[0.95] text-4xl md:text-6xl text-[#F8F8F5]">
            Not a writing service. A <span className="font-serif-accent font-light">positioning</span> discipline.
          </h2>
        </FadeUp>

        <div className="divide-y divide-[#27272A] border-t border-[#27272A]">
          {PRINCIPLES.map((c, i) => (
            <FadeUp key={c.n} delay={i * 0.05}>
              <div className="grid grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 group">
                <div className="col-span-12 md:col-span-3">
                  <span className="font-display text-7xl md:text-8xl font-bold text-stroke group-hover:text-[#DFFF00] group-hover:[-webkit-text-stroke:0] transition-all duration-500">
                    {c.n}
                  </span>
                </div>
                <div className="col-span-12 md:col-span-3">
                  <h3 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-[#F8F8F5]">
                    {c.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-6">
                  <p className="font-body text-base md:text-lg text-[#A1A1AA] leading-relaxed">{c.body}</p>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
